/**
 * URL base del backoffice, de donde cuelga Ingreso Brokers (FP-04): es una
 * pantalla de la otra aplicación. Contacto colgaba de acá hasta FP-40, que lo
 * trajo al portal como pantalla propia, y Registro Brokers hasta RP-12, que lo
 * sacó del menú.
 *
 * Se deriva del hostname en vez de fijarse por entorno, por el mismo motivo
 * que el backoffice deriva su `apiUrl` (ver `frontend-backoffice/src/
 * environments/environment.ts`): la imagen de `production` sirve más de un
 * dominio productivo (con y sin `www.`), así que una URL quemada en el build
 * apuntaría siempre al mismo lugar.
 *
 * Convención de dominios: al portal `phindi.com` le corresponde el backoffice
 * `admin.phindi.com`, igual que la API es `api.phindi.com`.
 */
export function urlBackoffice(porDefecto: string): string {
  if (typeof window === 'undefined') return porDefecto;

  const host = window.location.hostname;

  // En desarrollo local el portal corre en localhost: no hay dominio del que
  // derivar nada, así que se apunta al backoffice del entorno por defecto.
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]') {
    return porDefecto;
  }

  return `https://admin.${host.replace(/^www\./, '')}`;
}

/**
 * Rutas del backoffice enlazadas desde el menú del portal. Quedó una sola:
 * RP-12 sacó Registro Brokers ('/suscripcion') y FP-40 se llevó Contacto.
 */
export const RUTAS_BACKOFFICE = {
  ingresoBrokers: '/login',
} as const;
